angular
  .module('vppApp')
  .directive("timedContent", function() {

    return {
      restrict: 'EA',
      replace: true,
      controller: 'timedContentController',
      controllerAs: 'TCC',
      bindToController: true,
      itemId: '=',
      templateUrl: '/non-content/components/timed-content.html',
      link: function(scope, element, attrs, ctrl) {
        ctrl.itemId = attrs.itemId;
      }
    };
  });
